import { useAIChat } from '@/hooks/useAIChat';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { MoreHorizontal, Trash2, History } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const AIChatActions = () => {
  const { messages, clearMessages, restoreLastConversation } = useAIChat();
  const hasMessages = messages.length > 0;

  if (!hasMessages) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className="h-7 px-2 text-xs text-muted-foreground gap-1.5"
        onClick={restoreLastConversation}
      >
        <History className="size-3.5" />
        Restore last conversation
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="size-7 text-muted-foreground">
          <MoreHorizontal className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          className="text-destructive focus:text-destructive gap-2"
          onClick={clearMessages}
        >
          <Trash2 className="size-3.5" />
          Clear chat
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
